module.exports = __webpack_public_path__ + "static/media/hugo-logo-optimized.a5d519d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/slides/06-alternatives/images/hugo-logo-optimized.png
// module id = 968
// module chunks = 0